import React from 'react'
import { Button, Typography, theme } from 'antd'
import { PlusOutlined, MedicineBoxOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Title } = Typography

const BedManagementHeader = () => {
  const { token } = theme.useToken()

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        <MedicineBoxOutlined style={{ marginRight: '8px', fontSize: '24px', color: token.colorPrimary }} />
        <Title level={4} style={{ margin: 0, color: token.colorPrimary }}>
          Bed Management
        </Title>
      </div>
      <div style={{ marginLeft: 'auto', marginRight: '20px' }}>
        <Button
          icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          Add Bed
        </Button>
      </div>
    </div>
  )
}

export default BedManagementHeader
